/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_FB_BOT} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import queryString from 'query-string';
import {LIST_REPLY_STORE_REQUEST, LIST_REPLY_STORE_SUCCESS, LIST_REPLY_STORE_FAILURE} from "../../types";

const ReplyStoreAction = (params = [], page = 1, limit = 10, sort = "-created_at") => ({

    [RSAA]: {
        endpoint: () => {
            params.page = page;
            params.limit = limit;
            params.sort = sort;
            let queryParam = queryString.stringify(params);

            return `${SERVER_API_FB_BOT}/api/reply-stores?${queryParam}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            LIST_REPLY_STORE_REQUEST,
            {
                type: LIST_REPLY_STORE_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": LIST_REPLY_STORE_SUCCESS,
                        "data": data,
                    }
                },
            },
            {
                type: LIST_REPLY_STORE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": LIST_REPLY_STORE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }
});

export {ReplyStoreAction}